import template from './revokeForm.html';
import './revokeForm.scss';

export class RevokeFormController {
  onBrandsAutocompleteSearch(text) {
    this.onAutocompleteSearch({
      name: 'brands',
      text,
    });
  }
  onBrandsAutocompleteSelect(entity) {
    this.onAutocompleteSelection({
      name: 'brands',
      selection: entity,
    });
  }
  onToggleBrandsPillsVisibility() {
    this.onTogglePillsVisibility({ name: 'brands' });
  }
  removeBrandsPill(pill) {
    this.onRemovePill({
      name: 'brands',
      selection: pill,
    });
  }
  onUsersAutocompleteSearch(text) {
    this.onAutocompleteSearch({
      name: 'users',
      text,
    });
  }
  onUsersAutocompleteSelect(entity) {
    this.onAutocompleteSelection({
      name: 'users',
      selection: entity,
    });
  }
  onToggleUsersPillsVisibility() {
    this.onTogglePillsVisibility({ name: 'users' });
  }
  removeUsersPill(pill) {
    this.onRemovePill({
      name: 'users',
      selection: pill,
    });
  }
  selectScope(item) {
    this.onScopeSelection({ scope: item });
  }
}

export default {
  controller: RevokeFormController,
  template,
  bindings: {
    loading: '<',

    text: '@',
    ownerLabel: '@',
    ownerCaption: '<',

    onSave: '&',
    onCancel: '&',

    brands: '<',
    showBrands: '<',
    showAllBrands: '<',
    autocompleteBrandsResults: '<',

    users: '<',
    showUsers: '<',
    showAllUsers: '<',
    autocompleteUsersResults: '<',

    scopes: '<',
    selectedScope: '<',
    onScopeSelection: '&',

    onAutocompleteSearch: '&',
    onAutocompleteSelection: '&',

    onTogglePillsVisibility: '&',
    onRemovePill: '&',
  },
};
